import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=28adee7c&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=28adee7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28adee7c",
  null
  
)

export default component.exports